import { Group } from "@/entities/questionaire/Group";
import { ToolOpinionModel } from "@/entities/ToolOpinionModel";
import { Point } from "@/entities/chart/Point";
import { PointsCollection } from "@/entities/chart/PointsCollection";
import { expectedAnswerTypeEffective, expectedAnswerTypeTolerated } from "./questionaire/answers/ExpectedAnswerTypeReChallenge";

export class ToolOpinion {
  id: number;
  name: string;
  isExist: boolean;
  groups: Group[];
  otherRatings: ToolOpinionModel[];

  safety: number;
  efficacy: number;

  mustBeGivenIn: number[];
  mustBeGivenInHint?: string;

  mustNotBeGivenAfter: number[];
  mustNotBeGivenAfterHint?: string;

  mustBeGivenAfter: number[];
  mustBeGivenAfterHint?: string;

  hasToBeTolerated?: string | null;
  hasToBeToleratedHint?: string;

  hasToBeEffective?: string | null;
  hasToBeEffectiveHint? : string;

  rechallengePossibleAfter?: number | null;
  rechallengePossibleAfterHint?: string;
 toolBranchId?: number; // add this
  ignoreTool: boolean = false;

  constructor(
    id: number,
    name: string,
    isExist: boolean,
    groups: Group[],

    safety: number,
    efficacy: number,

    mustBeGivenIn: number[],
    mustBeGivenInHint: string,

    mustNotBeGivenAfter: number[],
    mustNotBeGivenAfterHint: string,

    mustBeGivenAfter: number[],
    mustBeGivenAfterHint: string,

    hasToBeTolerated: string | null,
    hasToBeToleratedHint: string,

    hasToBeEffective: string | null,
    hasToBeEffectiveHint: string,

    rechallengePossibleAfter: number | null,
    rechallengePossibleAfterHint: string,

    ignoreTool: boolean = false,
    otherRatings: ToolOpinionModel[] = []
  ) {
    this.id = id;
    this.name = name;
    this.isExist = isExist;
    this.groups = groups;
    this.otherRatings = otherRatings;
    this.safety = safety;
    this.efficacy = efficacy;

    this.mustBeGivenIn = mustBeGivenIn;
    this.mustBeGivenInHint = mustBeGivenInHint;

    this.mustNotBeGivenAfter = mustNotBeGivenAfter;
    this.mustNotBeGivenAfterHint = mustNotBeGivenAfterHint;

    this.mustBeGivenAfter = mustBeGivenAfter;
    this.mustBeGivenAfterHint = mustBeGivenAfterHint;

    this.hasToBeTolerated = hasToBeTolerated;
    this.hasToBeToleratedHint = hasToBeToleratedHint;

    this.hasToBeEffective = hasToBeEffective;
    this.hasToBeEffectiveHint = hasToBeEffectiveHint;

    this.rechallengePossibleAfter = rechallengePossibleAfter;
    this.rechallengePossibleAfterHint = rechallengePossibleAfterHint;

    this.ignoreTool = ignoreTool;
  }

  toOpinionModel(): any {
    const result = Object.assign({}, this);
    result.groups = this.groups.map(x => x.toOpinionModel());

    return result;
  }

  getRatingPoint(): Point {
    return new Point(this.id, this.efficacy, this.safety, this.name, "black");
  }

  getOtherRatingsPointsCollection(): PointsCollection {
    if (this.otherRatings == null || this.otherRatings.length === 0) {
      return new PointsCollection();
    }

    const points = this.otherRatings.map(
      x =>
        new Point(x.tool.id, x.efficacy, x.safety, x.tool.name, x.uniqueColor)
    );
    return new PointsCollection(points);
  }

  setSafety(safety: number): void {
    this.safety = safety;
  }

  setEfficacy(efficacy: number) {
    this.efficacy = efficacy;
  }
}
